module.exports = __webpack_public_path__ + "static/media/payment-property-icon.550f2208.svg";